import { Box, Link, Stack } from "@seneca/senekit";

import { hasUserPasswordProvider } from "services/firebase/auth/ssoProvider";

import { useIsPlurallApp } from "features/plurall";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";
import { linkToPasswordReset } from "features/sign-up/links";

import { SSOConnections } from "../../personal-information";
import useIsPasswordless from "../hooks/useIsPasswordless";
import { UpdatePasswordForm as Component } from "./UpdatePasswordForm";
import { UpdatePasswordPage as container } from "./UpdatePasswordPage";

// @ts-ignore
const UpdatePasswordPage = container(Component);

export default function LoginAndPasswordPage() {
  const isPlurallApp = useIsPlurallApp();
  const { isUserPasswordless, isPasswordlessLoading } = useIsPasswordless();

  const showUpdatePasswordSection =
    !isUserPasswordless && hasUserPasswordProvider();

  return (
    <Box paddingTop="large">
      <Stack space="xxlarge">
        {!isPlurallApp && !isNativeAppiOS() && <SSOConnections />}

        {!isPasswordlessLoading && (
          <>
            {showUpdatePasswordSection && <UpdatePasswordPage />}
            {isUserPasswordless && (
              <Link to={linkToPasswordReset()}>Set a new password</Link>
            )}
          </>
        )}
      </Stack>
    </Box>
  );
}
